import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import cn from 'classnames';
import { Box, Card, CircularLoader, Column } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { customPageStepIndex } from '~/client-flow/clientOb/ClientOnboarding.common.utils';
import { useCobConfig } from '~/client-flow/clientOb/CobConfigContext';
import { PdfViewer } from '~/components/PdfViewer/PdfViewer';
import { QuillViewerWithFetch } from '~/components/QuillViewerWithFetch/QuillViewerWithFetch';
import VideoPlayer from '~/components/VideoPlayer/VideoPlayer';
import { useStoreActions } from '~/contexts';
import { sortedPages } from '~/models/custom-page/model';
import styles from './customPagesStep.module.scss';
export const { CustomPagesStepTestIds } = getTestIds();
export const CustomPagesStep = (param)=>{
    let { currentStep } = param;
    var _customPageStepIndex_currentStep, _relationship_customPages;
    const { relationship } = useCobConfig();
    const { api } = useStoreActions();
    const [isVideoLoading, setIsVideoLoading] = useState(true);
    useEffect(()=>{
        setIsVideoLoading(true);
    }, [
        currentStep
    ]);
    const pageIndex = (_customPageStepIndex_currentStep = customPageStepIndex[currentStep]) !== null && _customPageStepIndex_currentStep !== void 0 ? _customPageStepIndex_currentStep : 0;
    const pages = sortedPages((_relationship_customPages = relationship.customPages) !== null && _relationship_customPages !== void 0 ? _relationship_customPages : []);
    const page = pages[pageIndex];
    if (!page) {
        return null;
    }
    const handleVideoReady = ()=>{
        setIsVideoLoading(false);
    };
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": CustomPagesStepTestIds.Root(),
        children: [
            page.type === 'text' && /*#__PURE__*/ _jsx(Card, {
                className: styles.card,
                testId: CustomPagesStepTestIds.TextContent(),
                children: /*#__PURE__*/ _jsx("div", {
                    className: styles.richTextContentWrapper,
                    children: /*#__PURE__*/ _jsx(QuillViewerWithFetch, {
                        queryKey: page.text.textId,
                        fetchContent: async ()=>{
                            const { value } = await api.texts.getLegalTermsRichTextContent(relationship.id, page.text.textId);
                            return value;
                        }
                    })
                })
            }),
            page.type === 'pdf' && /*#__PURE__*/ _jsx(Card, {
                className: cn(styles.card, styles.cardPdf),
                testId: CustomPagesStepTestIds.PdfContent(),
                children: /*#__PURE__*/ _jsx("div", {
                    className: styles.content,
                    children: /*#__PURE__*/ _jsx(PdfViewer, {
                        hideSinglePageLoader: true,
                        getFileUrl: async ()=>{
                            const { url } = await api.customPage.getDownloadUrl(relationship.vendor.id, page.pdf.pdfName);
                            return url;
                        },
                        pdfUniqueName: page.pdf.pdfName
                    })
                })
            }),
            page.type === 'video' && /*#__PURE__*/ _jsxs(Column, {
                className: styles.videoRoot,
                children: [
                    isVideoLoading && /*#__PURE__*/ _jsx(Box, {
                        className: styles.loaderWrapper,
                        testId: CustomPagesStepTestIds.VideoLoader(),
                        children: /*#__PURE__*/ _jsx(CircularLoader, {})
                    }),
                    /*#__PURE__*/ _jsx(Box, {
                        className: styles.videoWrapper,
                        testId: CustomPagesStepTestIds.VideoContent(),
                        style: {
                            display: isVideoLoading ? 'none' : 'flex'
                        },
                        children: /*#__PURE__*/ _jsx(VideoPlayer, {
                            url: page.video.videoUrl,
                            height: '100%',
                            onReady: handleVideoReady
                        })
                    })
                ]
            })
        ]
    });
};
